import React from 'react'

import { GetPdfQueryResult, IPdfContext, PdfContext } from './PdfContext'
import {
  PdfOutputDto,
  PdfTypeEnum,
  QueryGetPdfsByClientProposalIdArgs,
} from '../../../lib/graphql'

export const PdfContextProvider = ({
  pdfTypes = [],
  getPdfs,
  useGetPdfsByClientProposalIdQuery,
  isGeneratingDocuments,
  children,
}: {
  pdfTypes: PdfTypeEnum[]
  getPdfs: (
    pdfTypes: PdfTypeEnum[],
    regenerate?: boolean,
  ) => Promise<PdfOutputDto[]>
  useGetPdfsByClientProposalIdQuery: (
    agrs: QueryGetPdfsByClientProposalIdArgs,
  ) => GetPdfQueryResult
  isGeneratingDocuments?: boolean
  children: React.ReactNode
}) => {
  const context: IPdfContext = {
    pdfTypes,
    getPdfs,
    useGetPdfsByClientProposalIdQuery,
    isGeneratingDocuments,
  }

  return <PdfContext.Provider value={context}>{children}</PdfContext.Provider>
}
